/**
 * Operation Package関連のクエリキー
 */
export const operationPackageQueryKeys = {
  all: ['ga-operation-packages'] as const,
  list: () => [...operationPackageQueryKeys.all, 'list'] as const,
  detail: (id: string) =>
    [...operationPackageQueryKeys.all, 'detail', id] as const,
  countInProgress: (id: string) =>
    [...operationPackageQueryKeys.all, id, 'count-in-progress'] as const,
  patterns: (id: string) =>
    [...operationPackageQueryKeys.all, id, 'patterns'] as const,
  patternCountInProgress: (id: string, patternId: string) =>
    [
      ...operationPackageQueryKeys.all,
      id,
      'patterns',
      patternId,
      'count-in-progress',
    ] as const,
  instances: (id: string, patternId: string) =>
    [
      ...operationPackageQueryKeys.all,
      id,
      'patterns',
      patternId,
      'instances',
    ] as const,
  instance: (id: string, patternId: string, instanceId: string) =>
    [
      ...operationPackageQueryKeys.all,
      id,
      'patterns',
      patternId,
      'instances',
      instanceId,
    ] as const,
  instanceProgress: (id: string, patternId: string, instanceId: string) =>
    [
      ...operationPackageQueryKeys.all,
      id,
      'patterns',
      patternId,
      'instances',
      instanceId,
      'progress',
    ] as const,
  instanceTask: (
    id: string,
    patternId: string,
    instanceId: string,
    taskId: string,
  ) =>
    [
      ...operationPackageQueryKeys.all,
      id,
      'patterns',
      patternId,
      'instances',
      instanceId,
      'tasks',
      taskId,
    ] as const,
  instanceData: (id: string, patternId: string, instanceId: string) =>
    [
      ...operationPackageQueryKeys.all,
      id,
      'patterns',
      patternId,
      'instances',
      instanceId,
      'data',
    ] as const,
};
